import { combineReducers } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import userReducer from './slices/userSlice';
import profesorReducer from './slices/profesorSlice';
import cursoReducer from './slices/cursoSlice';
import materiaReducer from './slices/materiaSlice';
import eventoReducer from './slices/eventoSlice';
import permisoReducer from './slices/permisoSlice';
import permisoKinderReducer from './slices/permisoKinderSlice';
import estudianteReducer from './slices/estudianteSlice';
import reporteReducer from './slices/reporteSlice';
import libroDeCursoReducer from './slices/libroDeCursoSlice';
import asistenciaKinderReducer from './slices/asistenciaKinderSlice';
import accidenteKinderReducer from './slices/accidenteKinderSlice';
import skillsReducer from './slices/skillsSlice';
import ticketReducer from './slices/ticketSlice';
import certificateReducer from './slices/certificateSlice';
import reglamentoReducer from './slices/reglamentoSlice';
import circularReducer from './slices/circularSlice';
import estudianteFotoReducer from './slices/estudianteFotoSlice';
import seminarioReducer from './slices/seminarioSlice';
import altaMedicaReducer from './slices/altaMedicaSlice';
import inscripcionReducer from './slices/inscripcionSlice';

export const rootReducer = combineReducers({
  authState: authReducer,
  userState: userReducer,
  profesorState: profesorReducer,
  cursoState: cursoReducer,
  materiaState: materiaReducer,
  eventoState: eventoReducer,
  permisoState: permisoReducer,
  permisoKinderState: permisoKinderReducer,
  estudianteState: estudianteReducer,
  reporteState: reporteReducer,
  libroDeCursoState: libroDeCursoReducer,
  asistenciaKinderState: asistenciaKinderReducer,
  accidenteKinderState: accidenteKinderReducer,
  skillsState: skillsReducer,
  ticketState: ticketReducer,
  certificateState: certificateReducer,
  reglamentoState: reglamentoReducer,
  circularState: circularReducer,
  estudianteFotoState: estudianteFotoReducer,
  seminarioState: seminarioReducer,
  altaMedicaState: altaMedicaReducer,
  inscripcionState: inscripcionReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
